import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Grid } from './styles';

const Container = forwardRef(
  (
    {
      children,
      as = null,
      type = '',
      className = '',
      backgroundColor = null,
      backgroundImage = null,
      id = null,
    },
    ref,
  ) => {
    if (backgroundColor || backgroundImage) {
      return (
        <Wrapper
          data-testid="container-wrapper"
          ref={ref}
          backgroundColor={backgroundColor}
          backgroundImage={backgroundImage}
          className={className ? `${className}-wrapper` : ''}
        >
          <Grid
            as={as}
            id={id}
            className={`${className} ${type}`}
            $hasBgImg={backgroundImage}
            $hasBgColor={backgroundColor}
            data-testid="container-grid"
          >
            {children}
          </Grid>
        </Wrapper>
      );
    }
    return (
      <Grid
        as={as}
        id={id}
        className={`${className} ${type}`}
        ref={ref}
        data-testid="container-grid"
      >
        {children}
      </Grid>
    );
  },
);

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  id: PropTypes.string,
  as: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  backgroundColor: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  backgroundImage: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.node,
  ]),
};

export default Container;
